import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { I18nProvider } from "@/i18n";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Stats from "@/components/Stats";
import Services from "@/components/Services";
import HowItWorks from "@/components/HowItWorks";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import ContactDemo from "@/components/ContactDemo";
import Footer from "@/components/Footer";

const Landing = () => (
  <div className="App bg-background min-h-screen">
    <Navbar />
    <main>
      <Hero />
      <Stats />
      <Services />
      <HowItWorks />
      <Testimonials />
      <FAQ />
      <ContactDemo />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
